import {DataObject} from "../dataObject";
import TimeStamp from "../../timeStamp";
import store from "../../../store/store";
import {Spieler} from "../spieler/spieler";
//import SPIELER_CHANGE_HANDLER from "../spieler/spielerChangeHandler";
import SPIELER_MEMBERSHIP_HANDLER from "../spieler/spielerMembershipHandler";
//import {SPIELER_ACTION_SETTINGS} from "../SpielerActionIconList/spielerActionSettings";

export class SpielerAction extends DataObject{

    constructor(spieler, actionType, lvNr, verein){
        super();
        this.init(spieler, actionType, lvNr, verein)
    }

    async init(spieler, actionType, lvNr, verein){
        this.id = '';
    // status keys
        this.status_lvNr = lvNr;               // filled with lv-number
        this.status_lvVerein = lvNr + '' + verein;      // filled with lvVerein-number for search
        this.status_lvVerein_pending = [this.status_lvVerein];      // filled with lvVerein-number if pending, else empty
        this.status_spieler = spieler.id;
        this.undo_pending = null;
        this.spieler_temp = null;
        this.search_spieler = spieler.id;
    // creation ts
        this.createdBy = '';
        this.createdByName = '';
        this.createdAt = null;
    // processiong ts
        this.processedBy = '';
        this.processedByName = '';
        this.processedAt = null;
    // local
        this.local.definitions.databaseHandlerCall = 'spielerAction';
        //this.local.definitions.actionSettings = SPIELER_ACTION_SETTINGS;
        this.local.spieler = new Spieler;
        this.local.spieler.setFromDataObject(spieler);
    // content
        this.actionType = actionType; // z.B. passDuplikat
        let currentPassNrs = SPIELER_MEMBERSHIP_HANDLER.getLastValidPassNr(spieler.memberships);
        this.spieler = {
            passNr: currentPassNrs.regular,
            passNrLeihe: currentPassNrs.leihe,
            vorname: spieler.vorname,
            nachname: spieler.nachname,
            nationalitaet: this.local.spieler.private.nationalitaet
        };
        this.comment = '';
        this.actionDate = actionType === 'abmeldung' ?
                            TimeStamp.getTodayString() :
                            actionType === 'verlaengerung' ?
                            TimeStamp.getFirstDayOfMonthYear('07', '01') :
                            '';
        this.changes = [];
        if ( actionType !== 'edit' ) await this.local.spieler.private.loadFromDatabase(spieler.id)
        this.spieler.nationalitaet = this.local.spieler.private.nationalitaet
    }

    setTimeStamp(){
        this.createdAt = TimeStamp.getGMTTimestamp();
        this.createdByName = store.state.user.lastName;
        this.createdBy = store.state.user.uid;
    }
    setActionDate(actionDate){
        this.actionDate = actionDate;
    }

    setSpielerTemp(spieler){
        let spielerLocal = JSON.parse(JSON.stringify(spieler));
        delete spielerLocal.id;
        delete spielerLocal.local;
        delete spielerLocal.search;
        delete spielerLocal.memberships;
        delete spielerLocal.dates;
        delete spielerLocal.private.local;
        delete spielerLocal.private.id;
        this.spieler_temp = spielerLocal;
    }

    setActionDateForExcelDownload(action, deleteOption, selectedSportJahr){
        switch (action) {
            case 'abmeldung': return this.setActionDateForAbmeldung(deleteOption);
            case 'wiederanmeldung': return this.setActionDateForWiederanmeldung(selectedSportJahr);
        }
    }
        setActionDateForAbmeldung(deleteOption){
            if ( deleteOption === 'sportJahr' ) {
                this.actionDate = store.state.local.sportJahr.abmeldung.until;
            } /*else {
                if ( this.actionDate < TimeStamp.getTodayString() ||
                    this.actionDate > store.state.local.sportJahr.abmeldung.until ) {
                    return 'Das Abmeldedatum muss innerhalb dieses Sportjahres sein (aber nicht in der Vergangenheit)!';
                }
            }*/
            return '';
        }
        setActionDateForWiederanmeldung(selectedSportJahr){
            let today = TimeStamp.getTodayString();
            let sportJahr = store.state.local.sportJahr.getObjectFromSportJahrValue(selectedSportJahr);
            this.actionDate = sportJahr.from < today ? today : sportJahr.from;
            return '';
        }

    setUndo(undoObject){
        this.undo_pending = JSON.parse(JSON.stringify(undoObject))
    }

    updateLvVerein(lvNr, lvVerein, clearOld){
        this.status_lvNr = lvNr;
        this.status_lvVerein = lvVerein;
        if ( clearOld ) {
            this.status_lvVerein_pending = [lvVerein];
        } else {
            this.status_lvVerein_pending.push(lvVerein);
        }
    }

    /*setDuplikatPending(){
        this.status_duplikat_pending = true;
    }*/
    setEditPending(){
        this.status_edit_pending = true;
    }
    clearChanges(){
        this.changes = [];
    }
    refreshChanges(pendingChanges){
        pendingChanges.forEach( (pendingChange) => {
            let existingChange = this.changes.find(change => change.field === pendingChange.field );
            if ( existingChange ) {
                existingChange.valueOld = pendingChange.valueOld;
            } else {
                this.changes.push(pendingChange)
            }
        });
    }
    setId(id){
        this.id = id;
    }

    // new 2023
    autoConfirmDuplicateAndContentChanges(excel){
        if ( excel ) this.excel = 'kein Download'
        this.status_lvVerein_pending = []
        this.status_spieler = null
        this.undo_pending = null
        this.spieler_temp = null
        this.processedAt = TimeStamp.getGMTTimestamp()
        this.processedBy = 'System'
        this.processedByName = 'Automatisch bestätigt'
        if (this.status_edit_pending !== undefined) this.status_edit_pending = false
    }

}